import { Context } from '~/state'

export const contextMinusOneWeek = (context: Context): Context => {
  return {
    ...context,
    timeRange: {
      ...context.timeRange,
      from: context.timeRange.from.minus({ weeks: 1 }),
      to: context.timeRange.to.minus({ weeks: 1 }),
    },
  }
}
